var React = require('react');

function BoldChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.763 9.763 16 17.525 8.237 9.763l-2.474 2.474L16 22.475l10.237-10.238-2.474-2.474Z","key":0}),React.createElement("path",{"d":"M32 32V0H0v32h32Z","style":{"fill":"none"},"key":1})]);
}

BoldChevronDown.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = BoldChevronDown;

BoldChevronDown.default = BoldChevronDown;
